import { Component, inject, OnInit, signal } from '@angular/core';
import { KeywordsService } from '../../shared/services/keywords.service';
import { LeftSidebarComponent } from '../../shared/left-sidebar/left-sidebar.component';
import { form, FormField, FormRoot, requiredError, validate } from '@angular/forms/signals';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-keywords',
  standalone: true,
  imports: [LeftSidebarComponent, FormRoot, FormField],
  templateUrl: 'keywords.component.html',
})
export class KeywordsComponent implements OnInit {
  private keywordsService = inject(KeywordsService);
  keywords = signal<any[]>([]);
  prefixes = signal<any[]>([]);
  prefixModel = signal({
    prefix: '',
  });
  keywordModel = signal({
    keyword: '',
    prefixId: 0,
  });

  constructor(private toastr: ToastrService) {}

  prefixForm = form(this.prefixModel, {
    submission: {
      action: async () => this.addPrefix(),
    },
  });
  keywordForm = form(
    this.keywordModel,
    (path) => {
      validate(path.prefixId, ({ value }) =>
        value() === 0 ? requiredError({ message: 'Izaberi prefix' }) : undefined,
      );
    },
    {
      submission: {
        action: async () => this.addKeyword(),
        onInvalid: () => this.toastr.error('Izaberi prefix pre dodavanja keyword-a'),
      },
    },
  );

  ngOnInit() {
    this.getKeywordsAndPrefixes();
  }

  getKeywordsAndPrefixes() {
    this.keywordsService.getKeywordsAndPrefixes().subscribe({
      next: (data) => {
        this.keywords.set(data.provider_codes);
        this.prefixes.set(data.prefixes);
      },
      error: (err) => console.error(err),
    });
  }

  addPrefix() {
    this.keywordsService.addPrefix(this.prefixModel().prefix).subscribe({
      next: (data) => {
        if (data.added) {
          this.toastr.success('Dodat prefix');
          this.prefixes.set(data.prefixes);
          this.prefixModel.set({ prefix: '' });
        } else {
          this.toastr.error('Nije dodat prefix, verovatno nije jedinstven naziv');
        }
      },
      error: (err) => this.toastr.error('Došlo je do greške'),
    });
  }

  addKeyword() {
    this.keywordsService
      .addKeyword(this.keywordModel().keyword, this.keywordModel().prefixId)
      .subscribe({
        next: (data) => {
          if (data.added) {
            this.toastr.success('Dodat keyword');
            this.keywords.set(data.providerCodes);
            this.keywordModel.set({ keyword: '', prefixId: 0 });
            this.keywordForm().reset();
          } else {
            this.toastr.error('Nije dodat keyword, verovatno nije jedinstven naziv');
          }
        },
        error: (err) => this.toastr.error('Došlo je do greške'),
      });
  }

  updatePrefixId(event: Event) {
    const newId = Number((event.target as HTMLSelectElement).value);
    this.keywordModel.update((model) => ({ ...model, prefixId: newId }));
  }
}
